import React from 'react';
import { HistoryEvent } from '@api/types';
import { AppIcon } from '@common/AppIcon/AppIcon';
import { getHistoryAppId, getHistoryIcon } from '@react/constants/historyEvent';

function getIconElement(event: HistoryEvent): Maybe<React.ReactElement> {
  const className = getHistoryIcon(event);
  if (className) {
    return <i className={className} />;
  }
}

interface EventIconProps {
  event: HistoryEvent;
}

export const HistoryItemIcon: React.FC<EventIconProps> = ({ event }) =>
  getIconElement(event) || <AppIcon appId={getHistoryAppId(event)} size="small" skeletonStyle="tile" />;
